<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoFlow
      :account-number="current.accountNumber"
      :workflow-id="FlowType.Deceased"
      title="Deceased"
      data-testid="deceased-flow"
      @closed="flowClosed()"
    />
    <SoFlowExit
      v-model="exitWorkflowModal"
      @on-workflow-exit="exitWorkflow()"
    />
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../CustomerAccountInfoRail.vue"
  import SoFlow from "@/flows/SoFlow.vue"
  import SoFlowExit from "@/flows/SoFlowExit.vue"
  import { FlowType } from "@/flows/useCases"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoFlowExit,
      SoFlow,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        exitWorkflowModal: false,
        FlowType,
      }
    },
    methods: {
      flowClosed() {
        this.exitWorkflowModal = true
      },
      exitWorkflow() {
        this.exitWorkflowModal = false
        this.$router.push({ name: RouteNames.CustomerOverview })
      },
    },
  })
</script>
